// extracted by mini-css-extract-plugin
export default {"profile":"ProfileSection_profile__MWIlU","profile__item":"ProfileSection_profile__item__jDXPo","profile__name":"ProfileSection_profile__name__LGbGm"};